import React from 'react';
import './Privacy.css';
const Privacy: React.FC = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-header">
        <div className="container">
          <div className="privacy-logo">
            <img src="/choretap-logo.png" alt="ChoreTap Logo" />
          </div>
          <h1>Privacy & Security Policy</h1>
          <p className="privacy-subtitle">
            Your privacy and security are important to us. Learn how we protect your data.
          </p>
        </div>
      </div>
      <div className="privacy-content">
        <div className="container">
          <p className="last-updated">Last updated: April 8, 2026</p>
          <div className="policy-section">
            <h2>Data Collection and Use</h2>
            <p>
              We collect information you provide directly, such as your name, email, and family details, to create and manage your account.
              Usage data, including app interactions and chore activities, helps us improve our services.
              We do not sell your personal information to third parties.
            </p>
          </div>
          <div className="policy-section">
            <h2>Security Measures</h2>
            <p>
              Your data is encrypted in transit and at rest. We use industry-standard security practices to protect your information.
              Access to your account requires authentication, and we monitor for suspicious activity.
              Financial transactions are processed securely through trusted payment providers.
            </p>
          </div>
          <div className="policy-section">
            <h2>Your Rights</h2>
            <p>
              You have the right to access, update, or delete your personal information.
              You can opt out of non-essential communications at any time.
              If you have concerns about your data, please contact us.
            </p>
          </div>
          <div className="policy-section">
            <h2>Data Retention</h2>
            <p>
              We retain your data as long as your account is active or as needed to provide services.
              When you delete your account, we remove your personal information within a reasonable timeframe,
              except where required by law or for legitimate business purposes.
            </p>
          </div>
          <div className="policy-section">
            <h2>Children's Privacy</h2>
            <p>
              ChoreTap is designed for family use and is intended to be used by parents or guardians to manage their children's chores.
              We do not knowingly collect personal information directly from children under 13 without parental consent.
              Parents or guardians control all aspects of their family's account and have full access to modify or delete any information.
            </p>
          </div>
          <div className="policy-section">
            <h2>Third-Party Services</h2>
            <p>
              We use trusted third-party services for payment processing, analytics, and app functionality.
              These services may collect information as described in their own privacy policies.
              We only share the minimum information necessary for these services to function.
            </p>
          </div>
          <div className="policy-section">
            <h2>Updates to This Policy</h2>
            <p>
              We may update this Privacy & Security Policy from time to time.
              We will notify you of any significant changes through the app or via email.
              Your continued use of ChoreTap after changes are posted constitutes acceptance of the updated policy.
            </p>
          </div>
          <div className="policy-section contact-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy & Security policy, please contact our support team at{' '}
              <a href="mailto:support@choretap.app">support@choretap.app</a>.
            </p>
          </div>
        </div>
      </div>
      <div className="privacy-footer">
        <div className="container">
          <a href="/" className="back-home">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};
export default Privacy;
